<template>
  <modal @close="closeModal" ref="modal" icon="envelope-open-text">
    <template slot="header">
      <h2 class="p-5 text-center w-full" v-html="i18n.question_type"></h2>
    </template>
    <template slot="main">
      <div v-if="!isLoaded"></div>
      <enquiry-form
        v-else
        v-for="form in data.forms"
        :key="form.name"
        :name="form.name"
        :title="form.title"
        :subtitle="form.subtitle"
        :fields="form.fields"
        :is-expanded="expanded == form.name"
        :common="data.common"
        :software-options="data.available_software"
        @form-selected="selectForm"
      />
      <div class="p-5">
        <div class="flex items-center justify-between">
          <h2 class="text-xl mb-5" v-html="i18n.other_contact_title"></h2>
          <clock></clock>
        </div>
        <div v-html="i18n.other_contact"></div>
      </div>
    </template>
  </modal>
</template>

<script>
import Modal from "../Design/Modal";
import EnquiryForm from "./_EnquiryForm";

import { handleAxiosError } from "@/boot/functions";
import useSWRV from "@/store/swrv";
import { watch } from "@vue/composition-api";
import { useStore } from "@/store/composition";

export default {
  components: { Modal, EnquiryForm },
  setup() {
    const store = useStore();
    const { data, error, isLoaded } = useSWRV(
      store.state.app.routes.enquiries.create
    );

    watch(error, handleAxiosError);
    return { data, isLoaded };
  },
  data() {
    const expanded =
      this.$route.query.q ||
      this.$route.query._subview ||
      this.$route.query.supportModal ||
      null;
    return {
      expanded,
    };
  },
  methods: {
    selectForm(name) {
      this.expanded = name;
    },
    closeModal() {
      let query = Object.assign({}, this.$route.query);
      delete query.supportModal;
      delete query.q;
      this.$router.push({ query });
    },
  },
  computed: {
    i18n() {
      return this.$store.state.support.i18n;
    },
  },
};
</script>
